import { Switch as SwitchPrimitive } from "@base-ui/react/switch";

import { cn } from "../../lib/utils";

function Switch({
  className,
  size = "default",
  ...props
}: SwitchPrimitive.Root.Props & {
  size?: "sm" | "default";
}) {
  const isSm = size === "sm";

  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={cn(
        "relative box-border inline-flex shrink-0 cursor-pointer items-center justify-start rounded-full border border-transparent bg-tint-secondary p-0.5 outline-none hover:bg-tint-primary data-[hover]:bg-tint-primary focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background focus-visible:shadow-none data-[focus-visible]:ring-1 data-[focus-visible]:ring-ring data-[focus-visible]:ring-offset-2 data-[focus-visible]:ring-offset-background data-[focus-visible]:shadow-none disabled:cursor-not-allowed disabled:opacity-[0.33] data-[disabled]:cursor-not-allowed data-[disabled]:opacity-[0.33] data-[checked]:bg-bg-accent-primary data-[checked]:hover:bg-bg-accent-primary data-[checked]:data-[hover]:bg-bg-accent-primary data-[checked]:active:bg-bg-accent-primary data-[checked]:data-[active]:bg-bg-accent-primary",
        isSm ? "h-4 w-7" : "h-5 w-9",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "pointer-events-none block rounded-full border-[0.5px] border-border-primary-always-black bg-white bg-clip-padding shadow-L1 outline-none transition-transform duration-150 data-[checked]:translate-x-3.5",
          isSm
            ? "size-3 data-[checked]:translate-x-3"
            : "size-4 data-[checked]:translate-x-3.5",
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
